/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-22T15:12:16.202
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getRentPlaceOrderRetreatEditInit,
	getRentPlaceOrderRetreatView
} from '@api/rentmanage/RentPlaceOrderRetreat';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},
	actions: {
		getRentPlaceOrderRetreatEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentPlaceOrderRetreatEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentPlaceOrderRetreatView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentPlaceOrderRetreatView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
